/// <reference types="webpack/module" />
import React from 'react';
import { createBrowserRouter } from 'react-router';

import Notifications from 'components/Notifications';
import KeyboardModal from 'components/Keyboard/KeyboardModal';
import { registerRouter } from 'modules/router/navigate';
import syncRouterWithStore from 'modules/router/syncRouterWithStore';

import Router from './Router';
import RouteErrorBoundary from './RouteErrorBoundary';
import { store } from './Store';

const AppRoutes: React.FC = () => (
  <>
    <Router />
    <KeyboardModal />
    <Notifications />
  </>
);

// Catch-all data route: the app routes stay declarative (`<Routes>` in `Router.tsx`) as descendant routes.
// Not wrapped with Sentry's `wrapCreateBrowserRouter`: it would name every transaction after this catch-all (`/*`).
// Sentry names transactions from the wrapped `<Routes>` in `Router.tsx` instead (`/login`, `/checkin/:step`, ...).
export const router = createBrowserRouter([{ path: '*', element: <AppRoutes />, errorElement: <RouteErrorBoundary /> }]);

registerRouter(router);
syncRouterWithStore(store, router);

// Dev only: when HMR re-runs this module, stop the previous router (history listener + store sync).
import.meta.webpackHot?.dispose(() => router.dispose());
